// extracted by mini-css-extract-plugin
export default {"collapse":"RcCollapse_collapse__v46WE","collapseIcon":"RcCollapse_collapseIcon__43nI1","title":"RcCollapse_title__RcUVs","toRight":"RcCollapse_toRight__elrBy"};